<wk-ifirm-notes-panel>
    <wk-notes-panel [id]="id()" placeholder="JobNotes.Placeholder" />
</wk-ifirm-notes-panel>
